import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { all } from 'redux-saga/effects';
import configureStore from '../../helpers/configureStore';
import loading from '../../reducers/loading';
import loadingSaga from '../../sagas/loadingSaga';
import LoadingPane from '../../components/loading/LoadingPane';
import campEntry from '../../reducers/camp_entry';
import saga from '../../sagas/campEntrySaga';
import CampForm from '../../components/camp_entry/CampForm';
import Steps from '../../components/camp_entry/Steps';

function* rootSaga() {
  yield all([loadingSaga(), saga()]);
}

const store = configureStore({ loading, campEntry }, rootSaga);

const targetNode = document.getElementById('campEntryCampForm');
const initialValues = {
  authenticity_token: targetNode.getAttribute('data-authenticity-token'),
  ...JSON.parse(targetNode.getAttribute('data-initial-values')),
};

if (initialValues.parent_status !== undefined && typeof initialValues.parent_status.camp_id === 'string') {
  initialValues.parent_status.camp_id = Number.parseInt(initialValues.parent_status.camp_id, 10);
  if (targetNode.getAttribute('data-student-statuses') !== null) {
    const student_statuses = JSON.parse(targetNode.getAttribute('data-student-statuses'));
    let rentals = JSON.parse(targetNode.getAttribute('data-student-camp-rentals'));
    if (rentals !== undefined && rentals.length > 0) {
      rentals = rentals.map((x) => ({
        ...x,
        use_rental: x.use_rental ? 'true' : 'false',
      }));
    }

    initialValues.parent_status = {
      ...initialValues.parent_status,
      student_statuses_attributes: [
        {
          ...student_statuses,
          student_status_camp_rentals_attributes: rentals,
          pc_rental: student_statuses.pc_rental ? 'true' : 'false',
        },
      ],
    };
  }
}

// 初回フォームのみisBankをユーザー入力から取得するため、storeをCampFormと共有
const stepNode = document.getElementById('steps');
createRoot(stepNode).render(
  <Provider store={store}>
    <Steps
      current={stepNode.getAttribute('data-current')}
      loggedIn={stepNode.getAttribute('data-logged-in') === 'true'}
    />
  </Provider>
);

createRoot(targetNode).render(
  <Provider store={store}>
    <LoadingPane />
    <CampForm
      initialValues={initialValues}
      displays={JSON.parse(targetNode.getAttribute('data-displays'))}
      linkSvgPath={targetNode.getAttribute('data-link-svg-path')}
    />
  </Provider>
);
